export function isColoredCard(card) {
    return card.color !== null;
}
export function isWildCard(card) {
    return card.type === 'wild' || card.type === 'wild_draw_four';
}
const COLOR_ORDER = { red: 0, yellow: 1, blue: 2, green: 3 };
const TYPE_ORDER = {
    number: 0,
    skip: 1,
    reverse: 2,
    draw_two: 3,
    wild: 4,
    wild_draw_four: 5,
};
export function sortHand(hand) {
    return [...hand].sort((a, b) => {
        const colorA = a.color === null ? 4 : COLOR_ORDER[a.color];
        const colorB = b.color === null ? 4 : COLOR_ORDER[b.color];
        if (colorA !== colorB)
            return colorA - colorB;
        const typeA = TYPE_ORDER[a.type];
        const typeB = TYPE_ORDER[b.type];
        if (typeA !== typeB)
            return typeA - typeB;
        const valA = a.type === 'number' ? a.value : 0;
        const valB = b.type === 'number' ? b.value : 0;
        return valA - valB;
    });
}
export function getEffectiveColor(card) {
    if (isWildCard(card)) {
        return card.chosenColor ?? null;
    }
    return card.color;
}
//# sourceMappingURL=card.js.map